import { createContext, useContext } from 'react';
import { CameraSystemContextValue } from '../state';

export const CameraScannerContext = createContext<CameraSystemContextValue | null>(null);

export const useCameraScanner = () => {
    const context = useContext(CameraScannerContext);

    if (!context) {
        throw new Error('useCameraScanner must be used within CameraScannerProvider');
    }

    return context;
};
